import noUiSlider from 'nouislider'

document.addEventListener("DOMContentLoaded", function(){
    setTimeout(function(){
        var slider = document.getElementById('stepsRangeSlider');

        if (slider) {
            noUiSlider.create(slider, {
                start: [0, quota],
                connect: true,
                range: range,
                snap: true,
                pips: {
                    mode: 'steps',
                    stepped: true,
                    format: {
                        to: function (value) {
                            if (value == 6000000) {
                                return '∞';
                            }
                            if (value >= 1000000) {
                                return value/1000000 + 'm';
                            }
                            if (value >= 1000) {
                                return value/1000 + 'k';
                            }
                            return value;
                        },
                        from: function (value) {
                            if (value == '∞') {
                                return 6000000;
                            }
                            if (value.endsWith('m')) {
                                return parseInt(value) * 1000000;
                            }
                            if (value.endsWith('k')) {
                                return parseInt(value) * 1000;
                            }
                            return value;
                        }
                    }
                }
            });
    
            // Disable first handle that it's used only for color
            var origins = slider.getElementsByClassName('noUi-origin');
            origins[0].setAttribute('disabled', true);
    
            var quotaValue = document.getElementById('quotaValue');
            slider.noUiSlider.on('update', function (values, handle) {
                if (handle == 1) {
                    quotaValue.value = Number(values[handle]).toFixed(0);
                    quotaValue.dispatchEvent(new Event('change'));
                }
            });
    
            slider.noUiSlider.setHandle(1, quota, true, true);

            quotaValue.addEventListener('change', function(){
                if (Number(slider.noUiSlider.get()[1]).toFixed(0) != quotaValue.value) {
                    slider.noUiSlider.setHandle(1, quotaValue.value, true, true);
                }
            })
        }
    }, 500);
});